import script from "./KanbanUserFilter.vue?vue&type=script&lang=ts&setup=true"
export * from "./KanbanUserFilter.vue?vue&type=script&lang=ts&setup=true"

import "./KanbanUserFilter.vue?vue&type=style&index=0&id=5b7d4d34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7d4d34"]])

export default __exports__